import ContentPage from "../components/page/ContentPage";

export default function BuggySaoMiguel() {
  return (
    <ContentPage title="Buggy São Miguel dos Milagres">
      <p>
        Um passeio inesquecível percorrendo as melhores praias do Litoral Alagoano, partindo do extremo norte até São Miguel dos Milagres.
      </p>
      <br/>
      <div className="w-full relative">
        <img className="w-full" src="/sao-miguel/03.jpeg" alt="Picture of the something nice" />
      </div>
      <br/>
      <p>
        Pontos de Parada:
        <br/>
        <b>São Bento</b><br/>
        <b>Salgado</b><br/>
        <b>Japaratinga</b><br/>
        <b>Barreiras de Boqueirão</b><br/>
        <b>Mosteiro de São Bento </b><br/>
        <b>Túnel verde </b><br/>
        <b>Patacho</b><br/>
        <b>Praia das Lages</b><br/>
        <b>Porto da Rua</b><br/>
        <b>São Miguel dos milagres </b><br/>
        <b>Quatro Mirantes ao longo do percurso</b><br/>
        <b>Bica de água doce</b><br/>
        <b>Fábrica de bolo de goma e bolachas Maragogi</b><br/>
        <br />
        <div className="w-full relative">
          <img className="w-full" src="/sao-miguel/04.jpeg" alt="Picture of the something nice" />
        </div>
        <br />
        Duração do Passeio:
        <br/>
        <b>O dia todo</b><br/>
        <b>Saída as 7:30<br/>
          Retorno às 17:00 em Maragogi</b>
        <br/><br/>
      </p>
      <div className="w-full relative">
        <img className="w-full" src="/sao-miguel/01.jpeg" alt="Picture of the something nice" />
      </div>
      <p>
        <br/>
        Caso tenha dúvidas, teremos o maior prazer em tira-las. Fale Conosco.
      </p>
    </ContentPage>
  )
}